import React, { Component } from 'react';
import {connect} from "react-redux";
import {PropTypes} from "prop-types";

import {bindActionCreators} from "redux";
import * as Actions from "../../../../store/modules/journals";

import {getObjectLength} from "../../../../utils/functions"

class ScholarSide extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
    }

    render() {
        const fullText = this.props.fullText;
        console.log(fullText);
        // console.log(this.props.facet);
        return (
            <div className="right-side-group">
                {/*<div className="">*/}
                {/*    <h4 className="con-title d-flex align-items-center mb-3"><span*/}
                {/*        className="icon icon-size-16 icon-link-blue mr-2"></span>최신 보고서</h4>*/}
                {/*    <div>*/}
                {/*        <div className="dot-text-list">*/}
                {/*            <div className="list-cell"><a href="#"> EBSCOHost PDF(Full Text) EBSCOHost PDF(Full*/}
                {/*                Text))</a></div>*/}
                {/*            <div className="list-cell"><a href="#"> EBSCOHost PDF(Full Text) EBSCOHost PDF(Full*/}
                {/*                Text))</a></div>*/}
                {/*            <div className="list-cell"><a href="#"> EBSCOHost PDF(Full Text) EBSCOHost PDF(Full*/}
                {/*                Text))</a></div>*/}
                {/*            <div className="list-cell"><a href="#"> EBSCOHost PDF(Full Text) EBSCOHost PDF(Full*/}
                {/*                Text))</a></div>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}
                {fullText.length > 0 &&
                <div className="mt-px-20 pt-px-20 border-top border-lightgray">
                    <h4 className="con-title d-flex align-items-center mb-3">
                        <span className="icon icon-size-16 icon-link-blue mr-2"></span>Full Text</h4>
                    <div>
                        <div className="dot-text-list">
                            {fullText.map((item, num) => {
                                return (<div className="list-cell" key={num}><a href={item.url} target="_blank">{item.name}</a></div>)
                            })}
                        </div>
                    </div>
                </div>
                }
                <div className="mt-px-20 pt-px-20 border-top border-lightgray">
                    <h4 className="con-title d-flex align-items-center mb-3">
                        <span className="icon icon-size-16 icon-link-blue mr-2"></span>Extra Link</h4>
                    <div>
                        <div className="dot-text-list">
                            <div className="list-cell"><a href="#">Scholar Homepage</a></div>
                            <div className="list-cell"><a href="#">JCR</a></div>
                            <div className="list-cell"><a href="#">Scopus</a></div>
                            <div className="list-cell"><a href="#">KCI</a></div>
                        </div>
                    </div>
                </div>
                {/*<div className="mt-px-20 pt-px-20 border-top border-lightgray">*/}
                {/*    <h4 className="con-title d-flex align-items-center mb-3"><span*/}
                {/*        className="icon icon-size-16 icon-document-blue mr-2"></span>선·후행 저널</h4>*/}
                {/*    <div>*/}
                {/*        <div className="dot-text-list">*/}
                {/*            <div className="list-cell"><a href="#">Scholar_page_name</a></div>*/}
                {/*            <div className="list-cell"><a href="#">Scholar_page_name</a></div>*/}
                {/*            <div className="list-cell"><a href="#">Scholar_page_name</a></div>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}
                {/*<div className="mt-px-20 pt-px-20 border-top border-lightgray">*/}
                {/*    <h4 className="con-title d-flex align-items-center mb-3"><span*/}
                {/*        className="icon icon-size-16 icon-document-blue mr-2"></span>유사 저널</h4>*/}
                {/*    <div>*/}
                {/*        <a href="#" className="btn-side-link-item mb-19">*/}
                {/*            <div className="item-title">AAA-ARBEITEN AUS ANGLISTIK UN..</div>*/}
                {/*            <div className="badge-group">*/}
                {/*                <div className="badge-group-inner">*/}
                {/*                    <div className="badge outline-lightgray badge-sm"><span*/}
                {/*                        className="color-lightpurple">SCEI</span></div>*/}
                {/*                    <div className="badge outline-lightgray badge-sm"><span*/}
                {/*                        className="color-lightgreen">KCI</span></div>*/}
                {/*                    <div className="badge outline-lightgray badge-sm"><span*/}
                {/*                        className="color-lightorange">SCOPUS</span></div>*/}
                {/*                </div>*/}
                {/*            </div>*/}
                {/*        </a>*/}
                {/*        <a href="#" className="btn-side-link-item mb-19">*/}
                {/*            <div className="item-title">AAA-ARBEITEN AUS ANGLISTIK UN..</div>*/}
                {/*            <div className="badge-group">*/}
                {/*                <div className="badge-group-inner">*/}
                {/*                    <div className="badge outline-lightgray badge-sm"><span*/}
                {/*                        className="color-lightpurple">SCEI</span></div>*/}
                {/*                    <div className="badge outline-lightgray badge-sm"><span*/}
                {/*                        className="color-lightgreen">KCI</span></div>*/}
                {/*                    <div className="badge outline-lightgray badge-sm"><span*/}
                {/*                        className="color-lightorange">SCOPUS</span></div>*/}
                {/*                </div>*/}
                {/*            </div>*/}
                {/*        </a>*/}
                {/*        <a href="#" className="btn-side-link-item">*/}
                {/*            <div className="item-title">AAA-ARBEITEN AUS ANGLISTIK UN..</div>*/}
                {/*            <div className="badge-group">*/}
                {/*                <div className="badge-group-inner">*/}
                {/*                    <div className="badge outline-lightgray badge-sm"><span*/}
                {/*                        className="color-lightpurple">SCEI</span></div>*/}
                {/*                    <div className="badge outline-lightgray badge-sm"><span*/}
                {/*                        className="color-lightgreen">KCI</span></div>*/}
                {/*                    <div className="badge outline-lightgray badge-sm"><span*/}
                {/*                        className="color-lightorange">SCOPUS</span></div>*/}
                {/*                </div>*/}
                {/*            </div>*/}
                {/*        </a>*/}
                {/*    </div>*/}
                {/*</div>*/}
            </div>
        )
    }
}

export default connect(
    (state) => ({
        fullText : state.journals.fullText ? state.journals.fullText : [],
    }),
    (dispatch) => ({
        // dataActions: bindActionCreators(Actions, dispatch)
    }),
)(ScholarSide)

ScholarSide.propTypes = {
    fullText : PropTypes.array,
};
